import type { QueryClient } from "@tanstack/react-query"
import { characterLastMessageQueryOptions } from "@/entities/characters"
import { friendsQueryOptions } from "@/entities/friend"
import { cacheAuthResult } from "@/entities/user"
import { resolveOwner } from "./owner"
import { dropSnapshot, loadSnapshot } from "./storage"

export async function restoreSnapshot(
	queryClient: QueryClient,
): Promise<number | null> {
	const snapshot = loadSnapshot()
	if (!snapshot) return null

	if ((await resolveOwner()) !== snapshot.owner) {
		dropSnapshot()
		return null
	}

	const { user, friends, lastMessage } = snapshot
	await cacheAuthResult(queryClient, { exists: true, user })
	queryClient.setQueryData(friendsQueryOptions(user.id).queryKey, friends)
	if (lastMessage) {
		const { queryKey } = characterLastMessageQueryOptions(
			user.character,
			user.id,
		)
		queryClient.setQueryData(queryKey, lastMessage)
	}
	return user.id
}
